import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/profile/$id')({
  staticData: { breadcrumb: 'Profile', breadcrumbKey: 'K_BREADCRUMB_PROFILE' },
});
